// extracted by mini-css-extract-plugin
export default {"modalContent":"RecordDetailModal_modalContent__zP2Ju","detailTable":"RecordDetailModal_detailTable__fXO8q"};